module.exports = __webpack_public_path__ + "img/popularize-pic-02.e788ac88.png";